import React from 'react';

const UnhandledError = () => (
  <div className="bounds">
    <h1>Unexpected error, please try again.</h1>
    <a href="/">Go Home</a>
  </div>
);

export default UnhandledError;
